import ListItem from "../presents/ListItem"
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS'
import { FEATURES } from '../../../constants/state'
import getData from '../../../functions/getData'
import getImageUrl from '../../../functions/getImageUrl'
import hasDisplayTimes from '../functions/hasDisplayTimes'
import isOutOfRange from '../functions/isOutOfRange'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const mapStateToProps = (state, ownProps) => ({
    hasMcsApp: getData(state, [FEATURES, 'has_mcs_app']),
})

const ListItemAdvertisementContainer = ({
    itemType,
    itemData,
    hasMcsApp,
    isSelected,
    additionalClass,
    pathnameEdit,
    onDelete
}) => {
    if(!itemData) {
        return <ListItemNoDataContainer onDelete={onDelete} />
    }

    const { title, images, showInApp } = itemData

    const hasTimes = hasDisplayTimes(itemData)
    const outRange = hasTimes && isOutOfRange(itemData)

    const keyWithImg = images ? Object.keys(images).find(imgKey => images[imgKey] && images[imgKey].url) : false

    const {finalImageURl, imageUrl} = getImageUrl(keyWithImg ? images[keyWithImg] : null, false, true)

    return <ListItem
        title={title ? title : false}
        showImage={true}
        imageSrc={finalImageURl}
        imageSrcFallback={imageUrl}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        isInApp={hasMcsApp && showInApp}
        hasDisplayTimes={hasTimes}
        isOutOfRange={outRange}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemAdvertisementContainer)